import { useEffect, type ReactNode } from "react";
import { Tooltip } from "react-tooltip";
import DialogHost from "./DialogHost";
import Toasts from "./Toasts";
import OnBoardingWindowHost from "../onBoarding/OnBoardingWindowHost";
import GuidUi from "../onBoarding/GuideUi";
import { TooltipProvider } from "./tooltip/TooltipHost";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import { observeToastTooltips } from "./tooltip/toastTooltips";

/** Shared root for ESTADA and C1: local editor layers stay below global dialogs. */
export default function ApplicationShell({ children }: { children: ReactNode }) {
  useEffect(() => observeToastTooltips(), []);
  const dialogManager = globalThis.state?.dialogManager;
  useOnChangeWatcher(dialogManager);
  const modalOpen = Boolean(dialogManager?.isOpen && dialogManager.isModal);

  return (
    <TooltipProvider>
      <div id="applicationWorkspace" {...(modalOpen ? { inert: "" } : {})}
        // Keep percentage-height pages bounded by #root so their content can scroll.
        style={{ position: "relative", isolation: "isolate", zIndex: 0, width: "100%", height: "100%" }}>
        {/* Local dialogs and docks stay below connection portals mounted in the workspace. */}
        <div id="applicationContent"
          style={{ position: "relative", isolation: "isolate", zIndex: 0, width: "100%", height: "100%" }}>
          {children}
        </div>
      </div>
      <Toasts />
      <DialogHost />
      <OnBoardingWindowHost />
      <GuidUi />
      <Tooltip id="tv-tooltip" clickable disableTooltip={anchor => !!anchor?.closest("[data-tv-toast]")}
        style={{ maxWidth: "50vw", whiteSpace: "pre-line" }} />
      {/* Bildschirmkoordinaten des Guides dürfen keinen Dokument-Scrollbereich erzeugen. */}
      <div className="Theme" id="guideCursor" aria-hidden="true"
        style={{ position: "fixed", left: 0, top: 0, visibility: "hidden", pointerEvents: "none" }}>
        <div id="guideCursorClick" />
        <img />
      </div>
    </TooltipProvider>
  );
}
